import React from 'react';

import {TertiaryTabs} from '@pb/kit-component-tabs-v2';

type Props = {
    activeTab: string,
    setActiveTab: (tab: string) => void,
    children: React.ReactNode,
};

export const Tabs3Level = ({children, activeTab, setActiveTab}: Props) => (
    <TertiaryTabs value={activeTab} onChange={setActiveTab}>
        {children}
    </TertiaryTabs>
);
